/* eslint-disable camelcase */

declare function __webpack_require__(moduleId: string): unknown;

declare let __webpack_public_path__: string;

// @ts-expect-error TS MIGRATION ERROR WINDOW OBJECT
// eslint-disable-next-line prefer-const
__webpack_public_path__ = window.publicPath;
console.info(
  "===== this is webpack startup code, setting public path to:",
  __webpack_public_path__,
);
// since i just added a other module to the runtime, it ends up being the last module returned to the scope.
// For now, we need to re-export the container to the scope.
// you could use webpack internals to make this more dynamic, bue we will likely provide a internalized solution to attach a startup module
console.info(
  "base module ",
  __webpack_require__("webpack/container/entry/base"),
);

Object.assign(window, {
  base: __webpack_require__("webpack/container/entry/base"),
});
// @ts-expect-error TS MIGRATION WINDOW OBJECT
console.info("loaded base ", window.base);
